// Base mainnet (chain id 8453) contract config.
// FACTORY_ADDRESS is the BluePad v4 factory. It is empty
// until the on-chain factory is deployed with the project owner's deployer key.
export const FACTORY_ADDRESS = process.env.REACT_APP_FACTORY_ADDRESS || "";

export const BASE_CHAIN_ID = 8453;

// Uniswap v4 Universal Router on Base (source: Uniswap official deployments page).
export const UNIVERSAL_ROUTER = "0x6fF5693b99212Da76ad316178A184AB56D299b43";

// Forward-looking ABI for the BluePad v4 factory. Wired now so the launch
// flow calls it the moment FACTORY_ADDRESS is set post-deployment.
export const FACTORY_ABI = [
  {
    type: "function",
    name: "launch",
    stateMutability: "payable",
    inputs: [
      { name: "name", type: "string" },
      { name: "symbol", type: "string" },
      { name: "pairedToken", type: "address" },
      { name: "initialTick", type: "int24" },
      { name: "website", type: "string" },
      { name: "xAccount", type: "string" },
      { name: "tweet", type: "string" },
      { name: "initialBuy", type: "uint256" },
    ],
    outputs: [
      { name: "token", type: "address" },
      { name: "poolId", type: "bytes32" },
    ],
  },
  {
    type: "function",
    name: "getMetadata",
    stateMutability: "view",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [
      { type: "string" },
      { type: "string" },
      { type: "string" },
    ],
  },
  {
    type: "event",
    name: "Launched",
    inputs: [
      { name: "creator", type: "address", indexed: true },
      { name: "token", type: "address", indexed: true },
      { name: "pairedToken", type: "address", indexed: true },
      { name: "poolId", type: "bytes32", indexed: false },
    ],
  },
  {
    type: "event",
    name: "TokenMetadataSet",
    inputs: [
      { name: "poolId", type: "bytes32", indexed: true },
      { name: "website", type: "string", indexed: false },
      { name: "xAccount", type: "string", indexed: false },
      { name: "tweet", type: "string", indexed: false },
    ],
  },
];

// Starting tick for a new pool. Computed off-chain so the opening market cap
// (supply x price) matches the $2,000 target for the chosen paired token.
export const DEFAULT_INITIAL_TICK = 0;

// BluePadHook: creator fee claim. Paid out to the pool's registered creator.
export const HOOK_ABI = [
  {
    type: "function",
    name: "claimCreatorFees",
    stateMutability: "nonpayable",
    inputs: [{ name: "id", type: "bytes32" }],
    outputs: [],
  },
  {
    type: "function",
    name: "creatorFees",
    stateMutability: "view",
    inputs: [{ name: "id", type: "bytes32" }],
    outputs: [{ type: "uint256" }],
  },
];

export const ERC20_ABI = [
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    outputs: [{ type: "bool" }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ type: "uint256" }],
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ type: "uint8" }],
  },
];
